import React from "react";

// Tiny colored pill that surfaces the profile's gender at a glance.
// Pink = female, Blue = male. Renders nothing if gender is missing/unknown.
const STYLES = {
  female: {
    label: "Female",
    cls: "bg-pink-100 text-pink-800 border border-pink-200",
  },
  male: {
    label: "Male",
    cls: "bg-blue-100 text-blue-800 border border-blue-200",
  },
};

const GenderBadge = ({ gender, className = "" }) => {
  if (!gender) return null;
  const key = String(gender).toLowerCase();
  const meta = STYLES[key];
  if (!meta) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${meta.cls} ${className}`}
      aria-label={meta.label}
    >
      {meta.label}
    </span>
  );
};

export default GenderBadge;
